import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import { Box, FlexDiv, FlexRowDiv, H3 } from 'components/generic/HomePageComponents'
import { ValuePropStylizedP } from './Styled'

const ValuePropCard = ({ item: { title, description, imageUrl } }) => (
  <FlexRowDiv maxWidth='560px' marginBottom='20px' mr={['10px']} ml={['15px']}>
    <Box
      bg='grey'
      borderRadius='50%'
      height={['60px', '70px', '70px', '80px']}
      width={['60px', '70px', '70px', '80px']}
      marginTop={['0px', '10px']}
    >
      <GenericLazyLoadImage
        margin={['15px', '17.5px']}
        src={imageUrl}
        width={['30px', '35px', '35px', '45px']}
        textAlign='left'
        verticalAlign='middle'
        height={['30px', '35px', '35px', '45px']}
      />
    </Box>
    <FlexDiv
      paddingLeft='20px'
      flexDirection='column'
      alignItems='start'
      justifyContent='start'
      maxWidth={['250px', '300px', '300px', '400px']}
    >
      <H3 marginTop='0px' marginBottom='5px' fontSize={['24px', '28px']} textAlign='left'>
        {title}
      </H3>
      <ValuePropStylizedP
        textAlign='left'
        marginTop='0px'
        fontSize={['18px', '20px']}
        lineHeight='1.3'
        maxWidth='400px'
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </FlexDiv>
  </FlexRowDiv>
)

export default ValuePropCard
